/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-07 15:09:44
 */

import {useState} from "react";
import {Button, Form, Input, message} from "antd";
import {useNavigate} from "react-router-dom";
import {getFindPassword} from "@/api/modules/register";
import {getQueryVariable} from "@/utils/util";
import { useTranslation } from "react-i18next";

const FindPasswordForm = () => {
	const {t} = useTranslation();

	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState<boolean>(false);

	const email = getQueryVariable("email");
	const eCode = getQueryVariable("code");
	console.log("email", email);
	console.log("code", eCode);

	// 登录
	const onFinish = async (resetForm) => {
		try {
			if (!email || !eCode) {
				return;
			}
			if (resetForm.password != resetForm.checkPassword) {
				message.error("The two passwords are inconsistent");
				return;
			}
			setLoading(true);

			getFindPassword({
				...resetForm,
				code: eCode,
				email: email
			}).then((res) => {
				if (res.code === 200) {
					message.success("Password reset successfully");
					navigate("/login");
				}
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<div className="title">
				<span>Set new password</span>
			</div>
			<Form
				form={form}
				name="basic"
				labelCol={{span: 5}}
				initialValues={{remember: true}}
				onFinish={onFinish}
				size="large"
				autoComplete="off"
			>
				<Form.Item
					label={<span className="label">New Password</span>}
					labelCol={{span: 24}}
					required={false}
					name="password"
					rules={[
						{required: true, message: "Password is required"},
						{
							required: true,
							message: t("tips.password.rules"),
							pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/
						}
					]}
				>
					<Input.Password placeholder="Enter new Password"/>
				</Form.Item>

				<Form.Item
					label={<span className="label">Confirm Password</span>}
					labelCol={{span: 24}}
					required={false}
					name="checkPassword"
					rules={[
						{required: true, message: "Password is required"},
						{
							required: true,
							message: t("tips.password.rules"),
							pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/
						}
					]}
				>
					<Input.Password placeholder="Confirm new password"/>
				</Form.Item>
				<Form.Item className="login-btn">
					<Button
						style={{
							width: "100%",
							marginTop: "1rem",
							fontSize: "1rem",
							lineHeight: "1.5rem",
							color: "#FFF",
							backgroundColor: "#565BDD",
						}}
						htmlType="submit"
						loading={loading}
					>
						Save Password
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default FindPasswordForm;
